{
    "ShowMore": "Mostre mais",
    "ShowLess": "Mostre menos",
    "NAME": "LanguageSnackbar"
}